import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-project-material-copy',
  templateUrl: './new-project-material-copy.component.html',
  styleUrls: ['./new-project-material-copy.component.css'],
})
export class NewProjectMaterialCopyComponent {
  isMaximize: any;
  submitted: any;
  modalLabel: any;
  projectName: any;
  componentId: any;
  myProjectPackMaterialCopy!: FormGroup;
  @Output() saveNewPackMaterialCopy = new EventEmitter<any>();
  constructor(private formBuilder: FormBuilder, private modal: CustomModalService) {
    this.projectName = this.modal?.modalService?.config?.initialState?.['projectName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['modalLable'];
    this.componentId = this.modal?.modalService?.config?.initialState?.['componentId'];
  }

  ngOnInit() {
    this.myProjectPackMaterialCopy = this.formBuilder.group({
      projectPackMaterialName: [
        this.projectName + '_Copy',
        [Validators.required, Validators.maxLength(50), noWhitespaceValidator],
      ],
    });
  }
  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().startsWith(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    if (this.myProjectPackMaterialCopy.valid) {
      const payload = {
        id: this.componentId,
        name: this.myProjectPackMaterialCopy.controls['projectPackMaterialName'].value,
      };
      this.saveNewPackMaterialCopy.emit(payload);
    }
  }
}
